export default __webpack_public_path__ + "static/media/sages.7ed6ceeb.webp";